import React from "react";

import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import Grid2 from "@mui/material/Grid2";
import Header from "./Header";
import AppBar from "./AppBar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import MobileAppBar from "./MobileAppBar";
import { AuthProvider } from "../contexts/AuthContext";

const theme = createTheme({
  typography: {
    fontFamily: "Alegreya Sans SC, Trebuchet MS",
    fontSize: 16,
    fontWeight: 100,
  },
  palette: {
    primary: { main: "#5B7195" },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: "Economica",
        },
      },
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sizing: {
        xs: {
          usedHeight: 51,
          usedWidth: 30,
          footer: 25,
        },
        sm: {
          usedHeight: 191.16,
          usedWidth: 0,
          footer: 62.16,
        },
        vh: window.innerHeight,
        vw: window.innerWidth,
      },
      dimensionTimeout: null,
    };
  }

  handleDimensions = async () => {
    if (this.state.dimensionTimeout) {
      clearTimeout(this.state.dimensionTimeout);
    }
    this.setState({
      dimensionTimeout: setTimeout(() => {
        const innerHeight = window.innerHeight;
        const innerWidth = window.innerWidth;
        const sizing = { ...this.state.sizing };
        sizing.vh = innerHeight;
        sizing.vw = innerWidth;
        this.setState({ sizing });
      }, 500),
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleDimensions);
  }

  render() {
    const { sizing } = this.state;
    return (
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Grid2
            container
            direction="column"
            spacing={0}
            sx={{
              width: {
                xs: `${sizing.vw - sizing.xs.usedWidth}px`,
                sm: `${sizing.vw - sizing.sm.usedWidth}px`,
              },
              maxWidth: "100%",
              minHeight: {
                xs: `${sizing.vh - sizing.xs.footer}px`,
                sm: `${sizing.vh - sizing.sm.footer}px`,
              },
              backgroundColor: "white",
              overflowX: "hidden",
            }}
          >
            <Header sizing={sizing} />
            <AppBar sizing={sizing} />
            <Outlet context={{ sizing }} />
          </Grid2>
          <Footer sizing={sizing} />
          <MobileAppBar sizing={sizing} />
        </AuthProvider>
      </ThemeProvider>
    );
  }
}

export default App;
